<template>
  <div class="licorice-result">
    <div class="video-area">
      <h3>本の準備ができました。</h3>
      <div class="video-button" @click="onVideoBtnClick">
        <img :src="posterPath" alt="" >
        <video preload="auto" :poster="posterPath" v-if="isSp" :src="source"></video>
      </div>
      <div class="limit-datetime">閲覧可能期間：{{ resultLimit }}</div>
    </div>

    <template v-if="nowOrderCount >= 500">
      <sns-licorice :sharedata="sharedata"></sns-licorice>
    </template>

    <template v-else >
      <div class="thanks-mess">
        <img src="/static/img/licorice/lp/img_letter.png">
        <!--<sns-licorice :sharedata="sharedata" :only-twitter="true"></sns-licorice>-->
      </div>
    </template>

    <template v-if="!isSp">
      <transition>
        <div class="video-modal" v-show="isVideoOpen" :class="{open: isVideoOpen}">
          <div class="wrap">
            <video controls preload="auto" :src="source"></video>
            <div class="backcover"></div>
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
export default {
  name: "LicoriceVideoPlayer",
  components: {
    videoPlayer
  },
  data () {
    return {
      isVideoOpen: false,
      posterPath: '/static/img/licorice/detail/thum_movie.png',
      vd: null,
      vdbg: null,
      defSharedata: {
        twitter: {
          galabel: 'twitter_licorice_arrival'
        },
        line: {
          galabel: 'line_licorice_arrival'
        },
        facebook: {
          galabel: 'facebook_licorice_arrival'
        }
      }
    }
  },
  computed: {
    isSp () {
      let res = false
      const regexp = /Android|iPhone|iPad|iPod/i;
      if(window.navigator.userAgent.search(regexp) !== -1){
        res = true
      }
      return res
    },
    videowidth() {
      return '100px'
    },
    sharedata () {
      const res = {}
      res.twitter = {
        text: this.textTwitter,
        galabel: this.defSharedata.twitter.galabel
      }
      res.line = {
        text: this.textLine,
        galabel: this.defSharedata.line.galabel
      }
      res.facebook = {
        galabel: this.defSharedata.facebook.galabel
      }
      return res
    }
  },
  props: {
    source: {
      type: String,
      default: ''
    },
    resultLimit: {
      type: String,
      default: ''
    },
    textTwitter: {
      type: String,
      default: ''
    },
    textLine: {
      type: String,
      default: ''
    },
    nowOrderCount: {
      type: String,
      default() {
        return ''
      }
    }
  },
  mounted () {
    //this.vd = document.createElement('VIDEO')
    this.vd = this.$el.querySelector('.video-modal video')
    this.vdbg = this.$el.querySelector('.video-modal .backcover')
    if(this.isSp){
      this.vd = this.$el.querySelector('.video-button video')
    }else{
      this.vd = this.$el.querySelector('.video-modal video')
      this.vdbg = this.$el.querySelector('.video-modal .backcover')
    }

  },
  methods: {
    onVideoBtnClick () {
      this.isVideoOpen = true
      if(this.isSp) {
        if (!!this.vd.requestFullScreen) {
          this.vd.requestFullScreen();
        } else if (!!this.vd.webkitRequestFullScreen) {
          this.vd.webkitRequestFullScreen();
        } else if (!!this.vd.webkitEnterFullscreen) {
          this.vd.webkitEnterFullscreen();
        } else if (!!this.vd.mozRequestFullScreen) {
          this.vd.mozRequestFullScreen();
        } else if (!!this.vd.msRequestFullscreen) {
          this.vd.msRequestFullscreen();
        }
        this.vd.currentTime = 0
        this.vd.play()
      } else {
        this.vd.style.width = 'auto'
        this.vd.style.height = '100vh'
        this.vd.style.pointerEvents = 'auto'
        this.vdbg.addEventListener('click', this.onVideoBgClick)
        this.vd.currentTime = 0
        this.vd.play()
      }

      this.vd.addEventListener('ended',this.onVideoEnded)
    },
    onVideoEnded () {
      this.vd.removeEventListener('ended',this.onVideoEnded)
      this.vd.pause()
    },
    onVideoBgClick () {
      this.vdbg.removeEventListener('click', this.onVideoBgClick)
      this.isVideoOpen = false
      this.vd.style.pointerEvents = 'none'
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../sass/variables/index';
.licorice-result {
  margin: 0 -16px 0;
  width: 100vw;
  background: $brown-7;
  @include mq (){
    width: 580px;
  }
  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 24px;
    background: $gray-light;
    border-bottom: 1px solid $gray-10;
  }
  .video-area {
    width: 100%;
    background: url('/static/img/licorice/detail/bg_hondana.png');
    background-size: cover;
    color: $brown-7;
    padding: 24px 0;
    margin-bottom: 24px;
    h3 {
      font-family: $font_mincho;
      margin: 0 auto 24px;
      width: 100%;
      text-align: center;
      font-size: 20px;
      line-height: 1;
      text-shadow: 4px 2px 4px #000000;
      letter-spacing: 1px;
    }
    .video-button {
      width: 52vw;
      height: 91.06vw;
      margin: 0 auto 24px;
      cursor: pointer;
      position: relative;
      img {
        width: 100%;
        height: auto;
        pointer-events: none;
        position: absolute;
        top: 0;
        left :0;
        z-index: 11;
      }
      video {
        width: 52vw;
        height: 80vw;
        border-radius: 5vw;
        position: absolute;
        pointer-events: none;
        top: 0;
        left :0;
        z-index: 10;
      }
      @include mq () {
        width: 300px;
        height: 521px;
      }
    }
    .limit-datetime {
      width: 100%;
      text-align: center;
      font-size: 10px;
      line-height: 1;
    }
  }
  .video-modal {
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 999999;
    margin: 0 auto;
    .wrap {
      width: 100%;
      height: 100%;
      position: relative;
      video {
        display: block;
        width: 100%;
        margin: 0 auto;
        height: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }
      .backcover {
        background: rgba(0,0,0,0.5);
        width: 100%;
        height: 100%;
      }
    }
  }
  .thanks-mess {
    img {
      width: 100%;
      display: block;
      margin-bottom: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/LicoriceVideoPlayer.vue